import { render, staticRenderFns } from "./TableBreadcrumb.vue?vue&type=template&id=d354a4ea"
import script from "./TableBreadcrumb.vue?vue&type=script&lang=js"
export * from "./TableBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports